export default __webpack_public_path__ + "static/aragon-2fe00e661f9ed14e80fa291a96761c72.png";